import React from 'react';
import { FieldType, FormFieldRendererProps } from './types';
import CWTextField from './CWTextField';
import CWNumberField from './CWNumberField';
import CWTextArea from './CWTextArea';
import CWSelectField from './CWSelectField';
import CWAutocompleteField from './CWAutocompleteField';

const FormFieldRenderer: React.FC<FormFieldRendererProps> = (props) => {
  const { field } = props;

  switch (field.type) {
    case FieldType.TEXT_FIELD:
      return <CWTextField field={field} />;
    case FieldType.INTEGER:
      return <CWNumberField field={field} />;
    case FieldType.FLOAT:
      return <CWNumberField field={field} float={true} />;
    case FieldType.TEXT_AREA:
      return <CWTextArea field={field} />;
    case FieldType.SELECT:
      return <CWSelectField field={field} />;
    case FieldType.AUTOCOMPLETE:
      return <CWAutocompleteField field={field} />;
    default:
      return null;
  }
};

export default FormFieldRenderer;
